import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const Account = () => {

  /* ===================== REGISTER ===================== */
  const [registerForm, setRegisterForm] = useState({
    username: '',
    email: '',
    phone: '',
    password: ''
  });

  const handleRegisterChange = (e) => {
    setRegisterForm({ ...registerForm, [e.target.name]: e.target.value });
  };

  const handleRegisterSubmit = async (e) => {
  e.preventDefault();

  try {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const res = await fetch(
      `${BACKEND_URL}/api/registerCustomerAPI`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(registerForm),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      alert(data.message || "Registration failed ❌");
      return;
    }

    alert("Registered successfully 🎉");

    setRegisterForm({
      username: "",
      email: "",
      phone: "",
      password: "",
    });

  } catch (err) {
    console.error(err);
    alert("Something went wrong");
  }
};


  /* ===================== LOGIN ===================== */
const [loginForm, setLoginForm] = useState({
  email: "",
  password: ""
});

const [cartItems, setCartItems] = useState([]);
const [cartTotal, setCartTotal] = useState(0);

const handleLoginChange = (e) => {
  setLoginForm({ ...loginForm, [e.target.name]: e.target.value });
};

const login = async (email, password) => {
  const res = await fetch(
    "https://ecom.brightcodeapp.com/wp-json/jwt-auth/v1/token",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: email,
        password: password
      })
    }
  );
  return await res.json();  
};

// Fetch cart data after login
const fetchCartData = async (token) => {
  try {
    const res = await fetch(
      "https://ecom.brightcodeapp.com/wp-json/wc/store/cart", // Replace with your cart endpoint
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (!res.ok) throw new Error("Failed to fetch cart");

    const data = await res.json();
    console.log("Cart data fetched:", data);
    setCartItems(data.items || []);
    setCartTotal(data.total || 0);
    localStorage.setItem("cartItems", JSON.stringify(data.items || []));
    localStorage.setItem("cartTotal", JSON.stringify(data.total || 0));
  } catch (err) {
    console.error("Cart Fetch Error:", err);
  }
};

const handleLoginSubmit = async (e) => {
  e.preventDefault();

  try {
    const data = await login(loginForm.email, loginForm.password);

    if (data.token) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data));
      alert("Login successful ");
      console.log("LOGIN:", data);

      // Fetch cart data after login
      await fetchCartData(data.token);

      // Redirect to checkout after login (optional)
      // navigate("/checkout");
    } else {
      alert(data.message || "Invalid login ❌");
    }
  } catch (err) {
    console.error("Login Error:", err);
  }
};


  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row gy-4">

          {/* ================= LOGIN ================= */}
          <div className="col-xl-6 pe-xl-5">
            <form onSubmit={handleLoginSubmit}>
              <div className="border border-gray-100 rounded-16 px-24 py-40 h-100">
                <h6 className="text-xl mb-32">Login</h6>

                <div className="mb-24">
                  <label className="text-lg fw-medium">Email / Username *</label>
                  <input
                    type="text"
                    className="common-input"
                    name="email"
                    placeholder="Enter Email or Username"
                    onChange={handleLoginChange}
                  />
                </div>

                <div className="mb-24">
                  <label className="text-lg fw-medium">Password *</label>
                  <input
                    type="password"
                    className="common-input"
                    name="password"
                    placeholder="Enter Password"
                    onChange={handleLoginChange}
                  />
                </div>

                <div className="mt-48">
                  <button type="submit" className="btn btn-main py-18 px-40">
                    Log in
                  </button>
                </div>
              </div>
            </form>
          </div>


          {/* ================= REGISTER ================= */}
          <div className="col-xl-6">
            <form onSubmit={handleRegisterSubmit}>
              <div className="border border-gray-100 rounded-16 px-24 py-40">
                <h6 className="text-xl mb-32">Register</h6>

                <div className="mb-24">
                  <label className="text-lg fw-medium">Username *</label>
                  <input type="text" className="common-input" name="username" onChange={handleRegisterChange} />
                </div>

                <div className="mb-24">
                  <label className="text-lg fw-medium">Email *</label>
                  <input type="email" className="common-input" name="email" onChange={handleRegisterChange} />
                </div>

                <div className="mb-24">
                  <label className="text-lg fw-medium">Mobile *</label>
                  <input type="tel" className="common-input" name="phone" onChange={handleRegisterChange} />
                </div>

                <div className="mb-24">
                  <label className="text-lg fw-medium">Password *</label>
                  <input type="password" className="common-input" name="password" onChange={handleRegisterChange} />
                </div>

                <div className="mt-48">
                  <button type="submit" className="btn btn-main py-18 px-40">
                    Register
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Account;
